module.exports = __webpack_public_path__ + "static/media/After-You.1cec5c3f.png";